import { render, staticRenderFns } from "./DetalleEntregaLibro.vue?vue&type=template&id=6cbaee80&"
import script from "./DetalleEntregaLibro.vue?vue&type=script&lang=js&"
export * from "./DetalleEntregaLibro.vue?vue&type=script&lang=js&"
import style0 from "./DetalleEntregaLibro.vue?vue&type=style&index=0&id=6cbaee80&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports